const en = {
  "Home": "Home",
  "Add": "Add",
  "Adding": "Adding",
  "Editing": "Editing",
  "Edit": "Edit",
  "Delete": "Delete",
  "Save": "Save",
  "Cancel": "Cancel",
  "Close": "Close",
  "Open": "Open",
  'Medicines': 'Medicines',
  'OverviewAbout': 'What is and what it is used for',
  'OverviewBeforeIntake': 'What you need to know before your child receives',
  'OverviewDosage': 'How is given',
  'OverviewSideEffects': 'Possible side effects',
  'OverviewSafetyData': 'How to store',
  'OverviewAdditionalInfo': 'Contents of the pack and other information',
  'LeafletUserInfo': 'Package leaflet: Information for the user',
  'WhatIsInLeaflet': 'What is in this leaflet:',
  'WhatIsInProduct': 'What is in',
  'ActiveIngredients': 'Active ingredients',
  'WhatLooksAndPackageContents': 'What looks like and contents of the pack',
  'FirstSideImprint': 'imprinted on one side with',
  'NotAllPackagesMarketed': 'Не всички видове опаковки могат да бъдат пуснати в продажба.',
  'MarketingAuthorisationHolderAndManufacturer': 'Marketing Authorisation Holder and Manufacturer',
  'Manufacturer': 'Manufacturer',
  'LeafletLastRevisedIn': 'This leaflet was last revised in',
  'BrandName': 'Brand Name',
  'GenericName': 'Generic Name',
  'Overview': 'Overview',
  'SideEffects': 'Side Effects',
  'Dosage': 'Dosage',
  'Professional': 'Professional',
  'Interactions': 'Interactions',
  'Leaflet': 'Leaflet',
  'InactiveIngredients': 'Inactive ingredients',
  'LeafletForUser': 'User Leaflet',
  'SmPC': 'Summary of product characteristics',
  'Leaflets': 'Leaflets',
  'FilesForDownload': 'Files for download',
  'Pregnancy': 'Pregnancy',
  'Breastfeeding': 'Breastfeeding',
  'MarketingAuthorisationHolder': 'Marketing Authorisation Holder',
  'StoragePlace': 'Storage Place',
  'StoragePlace and storagePrecautions': 'Storage Place and Precautions',
  'StoragePrecautions': 'Storage Precautions',
  'ShelfLife': 'Shelf Life',
  'ProductHandling': 'Product Handling',
  'ProductHandlingAndDisposal': 'Product Handling and Disposal',
  'ProductDisposal': 'Product Disposal',
  'SafetyData': 'Safety Data',
  'Profession': 'Profession',
  'Driver': 'Driver',
  'MachineOperator': 'Machine Operator',
  'DriveMachine': 'Driving / Machine',
  'When driving': 'When driving',
  'When using machine': 'When using machine',

  '5004': 'User prescription not found',
  '5005': 'User notification not found',
  '5006': 'Alarm date not valid',
  '5007': 'Notification scheduler not found',
  '6000': 'Active ingredient not found',
  '6001': 'Side effect item not valid',
  '6002': 'Dosage content item not valid',
  '6003': 'Disease not found',
  '6004': 'Food or alcohol item not found',
  '6005': 'Inactive ingredient not found',
  '6006': 'Manufacturer not found',
  '6007': 'Pregnancy or breastfeeding item not valid',
  '6008': 'Drive or machine item not valid',
  '6009': 'Safety data item not valid',
  'EmaEparFile': 'EMA EPAR File',
  'ImportFailed': 'Import Failed',
  'NotSynchronized': 'Not Synchronized',
  'SynchronizationFailed': 'Synchronization Failed',
  'NewAuthorisationGranted': 'New Authorisation Granted',
  'NewAuthorisationSuspended': 'New Authorisation Suspended',
  'DocumentGenerationFailed': 'Document Generation Failed',
  '13006': 'Document generation error. Please try again!',
  '13007': 'Transaction error. Contact DB administrator!',
  '13008': 'URL generation error. Please download EPAR file manually!',
  'Pregnancy and Breastfeeding': 'Pregnancy, breastfeeding and fertility',
  'DrivingAndUsingMachines': 'Diving and using machine',
  '13009': 'Synchronized medicines can not be deleted!',
  'EPAR': 'Summary of product characteristics and Package leaflet',
  'DocCountsEqual': 'Equal number',
  'SingleDoc': 'Single doc',
  'FirstAtStartToMissing': 'First at start',
  'LastAtEndToMissing': 'Last at end',
  'StebByStepFromStart': 'Steb by step',
  '13010': 'Multi Language documents count different!',
  'BDAhtml': 'BDA HTML',
  'SynchronizedBdaHtml': 'Synchronized BDA',
  'Please enter Email': 'Please enter Email',
  'Please enter valid Email': 'Please enter valid Email',
  '4003': 'Already exist User with this Email',
};

export default en;